import { createSelector, createSlice } from '@reduxjs/toolkit';

const sliceName = 'sidebar';

const sidebar = createSlice({
  name: sliceName,
  initialState: {
    open: false,
    pinned: true,
  },
  reducers: {
    setOpen: (state, action) => {
      state.open = action.payload;
    },
    toggle: state => {
      state.open = !state.open;
    },
    setPinned: (state, action) => {
      state.pinned = action.payload;
    },
    togglePinned: state => {
      state.pinned = !state.pinned;
    },
  },
});

// ACTIONS
export const sidebarActions = {
  ...sidebar.actions,
};

// SELECTORS
export const selectSidebar = state => state.app.sidebar;

export const selectIsOpen = createSelector(
  selectSidebar,
  sidebar => sidebar.open,
);

export const selectIsPinned = createSelector(
  selectSidebar,
  sidebar => sidebar.pinned,
);

export default sidebar;
